import { render, staticRenderFns } from "./ContentTrainingManagement.vue?vue&type=template&id=28ec3fe8&scoped=true"
import script from "./ContentTrainingManagement.vue?vue&type=script&lang=js"
export * from "./ContentTrainingManagement.vue?vue&type=script&lang=js"
import style0 from "./ContentTrainingManagement.vue?vue&type=style&index=0&id=28ec3fe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ec3fe8",
  null
  
)

export default component.exports